import PropTypes          from 'prop-types';
import React              from 'react';
import Table              from '../../core/data/table/Table';
import { useTranslation } from 'react-i18next';
import TableDefinition    from '../../core/data/table/TableDefinition';
import DateUtil           from '../../core/data/Date/DateUtil';
import OrdersExport       from './OrdersExport';
import {useOrderAffiliates} from '../../../hooks/useOrderAffiliate';

const PendingOrder = ({ affiliate, filters = {} }) => {
	const { t } = useTranslation();
	const [orders, fetch, loading] = useOrderAffiliates();

	return (
		<Table
			title={t('partnership_pending_order_title')}
			initialFilters={{ Affiliate__: affiliate.Affiliate__, ...filters }}
			fetch={fetch}
			data={orders}
			search={false}
			loading={loading}
			paperProps={{ elevation: 0 }}
			toolbarProps={{ style: { paddingLeft: 0 } }}
			extra={[
				<OrdersExport key='affiliate-order-export' affiliate={affiliate}/>
			]}
		>
			<TableDefinition label={t('history_order_date')} name='Invoice_Date'>
				{order => <DateUtil klbDateObj={order.Invoice_Date} format='LLL'/>}
			</TableDefinition>

			<TableDefinition label={t('partnership_suffer')} name='Affiliate_Surfer'>
				{order =>  order?.Affiliate_Surfer || 'N/A'}
			</TableDefinition>

			<TableDefinition label={t('partnership_level')} name='Level'>
				{order =>  parseInt(order.Level) || 'Direct'}
			</TableDefinition>

			<TableDefinition label={t('partnership_order_income')} name='Order__' align='right'>
				{order => order.Affiliate_Total.display_short ?? '-'}
			</TableDefinition>
		</Table>
	);
};

export default PendingOrder;

PendingOrder.propTypes = {
	affiliate: PropTypes.object.isRequired,
	filters: PropTypes.object,
};
